var util = require('../components/util');

function stickyNav() {
    var target = $('.mainInformations');
    var stickyNavTop = $('.images-scroll-content').offset().top;
    var scrollTop = $(window).scrollTop();

    if (scrollTop > (stickyNavTop - 100)) {
        target.removeClass('slideInUp').addClass('sticky slideInDown');
    } else {
        target.removeClass('sticky slideInDown').addClass('slideInUp');
    }
}

module.exports = function () {
    if ($(window).width() < 1430) {
        if ($('.images-scroll-content').length > 0) {
            stickyNav();
            $(window).scroll(function () {
                stickyNav();
            });
        }
    }

    $("#show-coupon-form").on("click", function() {
        $(".cart-promo-code-form").toggleClass( "cart-promo-code-form-show" );
    });

    $('body').on('product:afterAddToCart', function (e, response) {
        if (response.bambuserOTOCartUpdate) {
            var basketProductLineItems = {};
            basketProductLineItems = window.localStorage.getItem('basketProductLineItems') ? JSON.parse(window.localStorage.getItem('basketProductLineItems')) : {};
            Object.defineProperty(basketProductLineItems || {}, response.bambuserOTOCartUpdate.sku, {
                enumerable: true,
                value: response.bambuserOTOCartUpdate.uuid
            });
            window.localStorage.setItem('basketProductLineItems', JSON.stringify(basketProductLineItems));
        }
        var gtmData = [];
        var currencyCode = response.currencyCode != null ? response.currencyCode : "";
        var gtmPush = response.gtmPush != null ? response.gtmPush : null;

        if(response.error == false){
            $('.minicart .popover').spinner().start();
            $('html, body').addClass('disable_scrolling_minicart');
            var url;
            if (util.isMobile() || $(window).width() < 992) {
                url = $('.minicart-link-mobile').data('action-url');
            } else {
                url = $('.minicart-link-desktop').data('action-url');
            }
            $.get(url, function (datas) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(datas);
                $('.minicart .popover').slideDown('fast');

                quantitySelector();

                if (util.isMobile() || $(window).width() < 992) {
                    $('.minicart-link-mobile').focusout();
                } else {
                    $('.minicart-link-desktop').focusout();
                }
                $('#mini-cart-close-expanded').trigger('focus');
                $('.minicart .popover .mini-cart-close').focus();

                $.spinner().stop();
            });
            $.spinner().stop();
            $('.mini-cart-overlay').show();
            $('.add-to-cart-messages').hide();
        }else{
            $('.add-to-cart-messages').show();
        }

        if (gtmPush != null) {
            gtmData.push(gtmPush);
        }

        var addMethod = "product page";

        if ($('#pdp-sticky-wrapper').hasClass('fixed')) {
            addMethod = "sticky";
            $("html, body").scrollTop(0);
        }

        if ($("#quickbuy").length) {
            addMethod = "quick buy";
        }
        if ($('.page').attr('data-action') === 'Product-Show'){
            if ($(".shadefinderWrapper").length) {
                addMethod = "shade finder";
            }
            if (!$(".shadefinderWrapper").length && $(".vto-dialog").length) {
                addMethod = "virtual try on";
            }
        }

        if (!response.error) {
            dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': currencyCode,
                    'add': {
                        'products': gtmData
                    }
                },
                'add_method': addMethod
            });
        }
    });

    function quantitySelector() {
        $('.min-cart-content .quantity-button').on('click', function () {
            var newVal, oldValue, maxValue;
            var pid = ($(this).attr("data-pid"));
            var traductionText = $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').data('text');
            $.spinner().start();

            if (!pid){
                oldValue = $(".min-cart-content #quantity option:selected").text();
                maxValue = parseInt($('.min-cart-content #quantity option:last').val());

                if (this.id == "quantity-plus") {
                    newVal = parseFloat(oldValue) + 1;
                    $(".min-cart-content #quantity option[value='"+newVal+"']").prop('selected', true);
                    $(".min-cart-content #quantity option[value='"+newVal+"']").text(newVal);
                    $('.min-cart-content #quantity-minus').prop('disabled', false);
                    if (oldValue >= maxValue - 1) {
                        $('.min-cart-content #quantity-plus').prop('disabled', true);
                    }
                } else {
                    if (oldValue > 0) {
                        newVal = parseFloat(oldValue) - 1;
                        $(".min-cart-content #quantity option[value='"+newVal+"']").prop('selected', true);
                        $(".min-cart-content #quantity option[value='"+newVal+"']").text(newVal);
                        $('.min-cart-content #quantity-plus').prop('disabled', false);
                        if (oldValue <= 2) {
                            $('.min-cart-content #quantity-minus').prop('disabled', true);
                        }
                    } else {
                        newVal = 0;
                    }
                }
                $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
            } else {
                pid = ($(this).attr("data-pid"));
                oldValue = parseInt($('.min-cart-content .quantity[data-pid='+pid+'] option:selected').text());
                maxValue = parseInt($('.min-cart-content .quantity[data-pid='+pid+'] option:last').val());

                if (this.id === 'quantity-plus') {
                    newVal = parseFloat(oldValue) + 1;
                    $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
                    $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
                    $('.min-cart-content #quantity-minus[data-pid='+pid+']').prop('disabled', false);
                    if (oldValue >= maxValue) {
                        $('.min-cart-content #quantity-plus[data-pid='+pid+']').prop('disabled', true);
                        $.spinner().stop();
                    }
                } else {
                    if (oldValue > 0) {
                        newVal = parseFloat(oldValue) - 1;
                        $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").prop('selected', true);
                        $(".quantity[data-pid="+pid+"] option[value="+newVal+"]").val(newVal).change();
                        $('.min-cart-content #quantity-plus[data-pid='+pid+']').prop('disabled', false);
                        if (oldValue <= 2) {
                            $('.min-cart-content #quantity-minus[data-pid='+pid+']').prop('disabled', true);
                            $.spinner().stop();
                        }
                    } else {
                        newVal = 0;
                    }
                }
                $(this).parent('.pdp-qty-selector-content').find('#dynamic_update').text(traductionText + ' ' + newVal);
            }
        });
    }

    $(document).ready(function () {
        $('.change-my-shade').click(function(){
            $("html, body").scrollTop(0);
        })
        $('.pdp-content .tabPanel').each(function(){
            if (($(window).width() < 992)) {
                var currentTabPDP = $(this).attr('aria-labelledby');
                $(this).parent().prev('.navigationTabs').find('#' + currentTabPDP).removeAttr('role aria-labelledby')
                $(this).removeAttr('role aria-labelledby');
            }else{
                $('.pdp-content .tabPanel:first-child').addClass('active');
                $('.pdp-content .tabPanel:first-child').find('.pdp-description-block').addClass('active');
                $('.pdp-content .tabPanel:first-child').find('.pdp-description-content').addClass('show');
                $('.pdp-content .tabPanel:first-child').find('.pdp-description-title').attr('aria-expanded','true');
            }
        });
        (($(window).width() < 992)) ? $('#descriptionPanel').removeClass('active') : '' ;

        $('#descriptionTab, #ingredientTab, #howtoTab, #inspirationTab').on('keydown', function (e) {
            var currentTab = $(this).attr('aria-controls');
            switch (e.which) {
                case 39:
                    if ($(this).hasClass('active')) {
                        if ($(this).next('.nav-item').length > 0) {
                            $('.tab-content').find('.tabPanel ').removeClass('active');
                            $('.tab-content').find('#' + currentTab).next().addClass('active');
                            $(this).removeClass('active').attr({'aria-selected' : 'false', 'tabindex' : -1});
                            $(this).next('.nav-item').addClass('active').attr({'aria-selected' : 'true', 'tabindex' : 0}).focus();
                        }
                    }
                    break;
                case 37:
                    if ($(this).hasClass('active')) {
                        if ($(this).prev('.nav-item').length > 0) {
                            $('.tab-content').find('.tabPanel ').removeClass('active');
                            $('.tab-content').find('#' + currentTab).prev().addClass('active');
                            $(this).removeClass('active').attr({ 'aria-selected': 'false', 'tabindex' : -1});
                            $(this).prev('.nav-item').addClass('active').attr({ 'aria-selected': 'true', 'tabindex' : 0}).focus();
                        }
                    }
                    break;
            }
        })
            .on('click', function () {
                if (!$(this).hasClass('active')) {
                    var currentTab = $(this).attr('aria-controls');
                    $('.nav-item').removeClass('active').attr({'aria-selected' : 'false', 'tabindex' : -1});
                    $(this).addClass('active').attr({'aria-selected' : 'true', 'tabindex' : 0}).focus();
                    $('.tab-content').find('.tabPanel ').removeClass('active');
                    $('.tab-content').find('#' + currentTab).addClass('active');
                }
            });
    });

    $(document).ready(function () {
        var windowSize = $(window).width();
        var numberOfElementsToShow = 13;

        var newPDPdesign = $('.newPDP-container')[0] !== undefined ? true : false;
        if (newPDPdesign){
            if (windowSize < 1920 && windowSize >= 1890) {
                numberOfElementsToShow = 13;
            }
            if (windowSize < 1890 && windowSize >= 1770) {
                numberOfElementsToShow = 12;
            }
            if (windowSize < 1770 && windowSize >= 1650) {
                numberOfElementsToShow = 11;
            }
            if (windowSize < 1650 && windowSize >= 1530) {
                numberOfElementsToShow = 10;
            }
            if (windowSize < 1530 && windowSize >= 1410) {
                numberOfElementsToShow = 9;
            }
            if (windowSize < 1410 && windowSize >= 1280) {
                numberOfElementsToShow = 8;
            }
            if (windowSize < 1280 && windowSize >= 1160) {
                numberOfElementsToShow = 7;
            }
            if (windowSize < 1160 && windowSize >= 1040) {
                numberOfElementsToShow = 6;
            }
            if (windowSize < 1040 && windowSize >= 769) {
                numberOfElementsToShow = 12;
            }
        } else {
            if (windowSize > 1200) {
                numberOfElementsToShow = 15;
            }
            if (windowSize < 1200 && windowSize >= 1000) {
                numberOfElementsToShow = 11;
            }
            if (windowSize < 1000 && windowSize >= 769) {
                numberOfElementsToShow = 13;
            }
        }

        if (windowSize < 769 && windowSize >= 500) {
            numberOfElementsToShow = 9;
        }
        if (windowSize < 500 && windowSize >= 400) {
            numberOfElementsToShow = 7;
        }
        if (windowSize < 400 && windowSize >= 375) {
            numberOfElementsToShow = 6;
        }
        if (windowSize < 374 && windowSize >= 300) {
            numberOfElementsToShow = 5;
        }
        if (windowSize < 300) {
            numberOfElementsToShow = 2;
        }

        $('.color-swatchs-palette-container').each(function (index, elt) {
            var $this = $(elt);
            var numberOfElements = parseInt($this.find('li').length);
            // Order by full & default shade position to have the same display on load & after show/more less
            orderByFullShadePosition($this);
            orderByDefaultShadePosition($this);

            if (numberOfElements > numberOfElementsToShow) {
                var arialabeltext = $this.find('.loadMore').attr('aria-label');
                $this.find('.loadMore').show();
                $this.find('li:gt(' + (numberOfElementsToShow - 1) + ')').hide();
                $this.find('.loadMore').children('.loadmoreText').empty().html('+' + (numberOfElements - numberOfElementsToShow + 1));
                $this.find('.loadMore').attr('aria-label','+ ' + (numberOfElements - numberOfElementsToShow)+ " " + arialabeltext);
            }
        });

        $('.loadMore').click(function () {
            var paletteContainer = $(this).closest('.color-swatchs-palette-container');
            var numberOfElements = paletteContainer.find('li').length;
            $(this).attr('aria-pressed', false).hide();
            paletteContainer.find('.showLess').show();
            paletteContainer.find('.showLess').attr('aria-pressed', true);
            paletteContainer.find('.color-swatchs-palette').addClass('showMoreShade');

            // Order by full shade position
            orderByFullShadePosition(paletteContainer);

            if (numberOfElements > numberOfElementsToShow) {
                paletteContainer.find('li').show();
            } else{
                paletteContainer.find('.shades-list-container li:last-child button').focus();
            }
        });

        $('.showLess').click(function () {
            var paletteContainer = $(this).closest('.color-swatchs-palette-container');
            var numberOfElements = paletteContainer.find('li').length;
            $(this).attr('aria-pressed', false).hide();
            paletteContainer.find('.loadMore').attr('aria-pressed', true).show();
            paletteContainer.find('.loadMore').focus();
            paletteContainer.find('.color-swatchs-palette').removeClass('showMoreShade');

            // Order by default shade position
            orderByDefaultShadePosition(paletteContainer);

            if (numberOfElements > numberOfElementsToShow) {
                paletteContainer.find('li:gt(' + (numberOfElementsToShow - 1) + ')').hide();
            }
        });
    });

    function orderByFullShadePosition(paletteContainer) {
        paletteContainer.find('.shades-list-container li').sort(function(a, b) {
            return +a.getAttribute('data-full-position') - +b.getAttribute('data-full-position');
        }).appendTo(paletteContainer.find('.shades-list-container'));
    }

    function orderByDefaultShadePosition(paletteContainer) {
        paletteContainer.find('.shades-list-container li').sort(function(a, b) {
            return +a.getAttribute('data-default-position') - +b.getAttribute('data-default-position');
        }).appendTo(paletteContainer.find('.shades-list-container'));
    }

    $(window).on('load', function() {
        $(".ratings").show();
        $(".reviews").show();
    });
}
